export const ColumnOptions = {
	one: 1,
	two: 2,
	ten: 10,
} as const;

export type Columns = typeof ColumnOptions[keyof typeof ColumnOptions];
